import { Button, MenuItem, useBreakpointDown } from '@chronosphereio/chrono-ui';
import type { ReactNode } from 'react';

export interface QueryEditorToolbarActionItemProps {
  title: string;
  onClick: () => void;
  /** Leading icon shown only in wide viewports — dropped in the overflow menu. */
  icon?: ReactNode;
}

/**
 * Single toolbar action inside `QueryEditor.ToolbarActions`. Adapts rendering
 * based on viewport width: tertiary text button with optional icon when wide,
 * menu item (for the `MoreActions` overflow menu) when narrow.
 */
export function QueryEditorToolbarActionItem({ title, onClick, icon }: QueryEditorToolbarActionItemProps) {
  const isNarrow = useBreakpointDown('md', { breakpointSource: 'viewport' });

  if (isNarrow) {
    return <MenuItem onClick={onClick}>{title}</MenuItem>;
  }

  return (
    <Button variant="tertiary" size="small" onClick={onClick} StartIcon={icon}>
      {title}
    </Button>
  );
}
